/**
 * Formats a minor-unit amount for display in the diner's locale.
 *
 * Used for figures the client computes on the fly (a running basket total,
 * a live "Add · €14.50" button). Anything the server priced arrives with its
 * own `formatted` string, and that one should always be preferred — it is
 * what the order will actually say.
 */
export const formatMinorAmount = (minorAmount: number, currency: string): string =>
  new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(minorAmount / 100)
